

export class CompanyIdHoursRequest {
    companyId: number;
    currentHour: number;


    /**
     * 
     * @param companyId 
     * @param currentHour 
     */
    constructor(companyId: number, currentHour: number) {
        this.companyId = companyId;
        this.currentHour = currentHour;
    }
}